import moment from 'moment';
import { useState } from 'react';

const useSrComparativeMarketAnalysisCardController = ({ listing }) => {
  const listingHasSunSpot = !!(
    listing.avgLeadsComposition &&
    listing.avgLeadsCompositionDate &&
    listing.daysOnMarket >= 7
  );

  const [showLowerPriceModal, setShowLowerPriceModal] = useState(false);
  const [shouldCollapseCMA, setShouldCollapseCMA] = useState(listingHasSunSpot);

  const _hasCMAUpToDate = () => {
    if (!listing.comparativeMarketAnalysisUpdated || !listing.comparativeMarketAnalysisPdfUrl) {
      return false;
    }
    const monthsSinceCMAUpdate = moment().diff(
      moment(listing.comparativeMarketAnalysisUpdated),
      'months',
    );
    return monthsSinceCMAUpdate < 6;
  };

  return {
    lowerPriceModal: {
      isOpen: showLowerPriceModal,
      onOpen: () => setShowLowerPriceModal(true),
      onClose: () => setShowLowerPriceModal(false),
    },
    cma: {
      hasCMAUpToDate: _hasCMAUpToDate(),
      shouldCollapseCMA,
      toggleText: shouldCollapseCMA ? 'Show Old Report' : 'Hide Old Report',
      toggleIconUrl: '/images/blue-right-arrow-listing-row.svg',
      toggleIconOrientationTransform: shouldCollapseCMA
        ? 'rotate(90deg)'
        : 'rotate(270deg) translate(-2px, 0px)',
      onToggle: () => setShouldCollapseCMA(!shouldCollapseCMA),
      setShouldCollapseCMA: setShouldCollapseCMA,
    },
    listingHasSunSpot,
  };
};

export default useSrComparativeMarketAnalysisCardController;
